import {Route, Routes} from "react-router-dom";
import {RouterProps} from "../../../RouterProps";
import List from "./List";
import Post from "./Post";
import Detail from "./Detail";
import Edit from "./Edit";

export default function ReasonRouter(props: RouterProps) {
    return <>
        <Routes>
            <Route path={'/'} element={<List {...props} />} />
            <Route path={'/:userBlockReasonId'} element={<Detail {...props} />} />
            <Route path={'/:userBlockReasonId/edit'} element={<Edit {...props} />} />
            <Route path={'/post'} element={<Post {...props} />} />
        </Routes>
    </>
}